import { useEffect } from 'react';
import {
  Box,
} from '@mantine/core';

function ConnectingScreen({ onVideoEnd }) {
  // Loading video temporarily disabled
  useEffect(() => {
    onVideoEnd();
  }, [onVideoEnd]);

  return (
    <Box
      style={{
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000',
      }}
    />
  );
}

export default ConnectingScreen;
